/* global __webpack_public_path__:true */
(function (jimdoData) {
    "use strict";

    __webpack_public_path__ = jimdoData.cdnUrl;

})(require('jimdoData'));



//////////////////
// WEBPACK FOOTER
// ./webserver/document_root/s/js/webpackInitPublicPath.js
// module id = 277
// module chunks = 175 176 177 180 181 183 193 194